import React, {useState} from "react";
import {useIntl} from "react-intl";
import Button from "../../../../components/elements/Button/Button";
import Selector from "../../../../components/elements/Selector/Selector";
import ModalComp from "../../../../components/ModalComp/ModalComp";

export default function EventSheetAddSection({
                                                 modalIsOpen,
                                                 setModalIsOpen,
                                                 onAdd,
                                                 sectionOptions,
                                                 sections
                                             }) {
    const intl = useIntl();
    const [selected, setSelected] = useState(null);

    const handleAdd = () => {
        if (selected) {
            onAdd(selected.value);
            setSelected(null);
        }
    };

    return (
        <ModalComp
            title={intl.formatMessage({id: 'settings.event_sheet_templates.add_section'})}
            isOpen={modalIsOpen}
            className={"sign-contract"}
            close={true}
            onRequestClose={() => setModalIsOpen(false)}
        >
            <div className={"content"} style={{height: "unset", maxHeight: "unset"}}>
                <div className="row">
                    <div className="col-12">
                        <Selector
                            options={sectionOptions.filter(item => !Object.keys(sections).includes(item.value))}
                            value={selected}
                            onChange={setSelected}
                            placeholder={intl.formatMessage({id: 'settings.event_sheet_templates.select_section'})}
                        />
                    </div>
                    <div className="col-12 mt-3 d-flex justify-content-end">

                        <Button
                            className="btn-error"
                            icon="fa-solid fa-xmark"
                            value={intl.formatMessage({id: 'general.buttons.cancel'})}
                            onClick={() => setModalIsOpen(false)}
                        />
                        <Button
                            className="btn-primary ms-auto"
                            icon="fa-solid fa-plus"
                            value={intl.formatMessage({id: 'general.buttons.add'})}
                            onClick={handleAdd}
                            disabled={!selected}
                        />
                    </div>
                </div>
            </div>
        </ModalComp>
    );
}
